import React from 'react';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import EditPhrasePage from './EditPhrasePage';
import Backend from '../../../../Layouts/Backend';
import Loading from '../../../../Helpers/Loading';
import { bindActionCreators } from 'redux';
import phrasesActions from '../../../../../actions/phrases.actions';
import helper from '../../../../../utils/helper';

class EditPhrase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phrase: {},
      getPhraseError: {},
      departments: [],
      groups: [],
      loading: false,
      isSubmitting: false,
      errors: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {
      errors: prevState.errors,
    };
    if (nextProps.phrases.phrase !== prevState.phrase) {
      state.phrase = nextProps.phrases.phrase;
    }
    if (nextProps.phrases.getPhraseError !== prevState.getPhraseError) {
      state.getPhraseError = nextProps.phrases.getPhraseError;
    }
    // if (nextProps.configure.departments !== prevState.departments) {
    //   state.departments = nextProps.configure.departments;
    // }
    // if (nextProps.configure.groups !== prevState.groups) {
    //   state.groups = nextProps.configure.groups;
    // }
    // if (!prevState.errors.includes(nextProps.configure.getDepartmentsError)) {
    //   state.errors.push(nextProps.configure.getDepartmentsError);
    // }
    // if (!prevState.errors.includes(nextProps.configure.getGroupsError)) {
    //   state.errors.push(nextProps.configure.getGroupsError);
    // }
    state.errors = helper.centralizeError([nextProps.phrases.errors]);
    if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.configure.isSubmitting;
    }
    return Object.keys(state).length ? state : null;
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.setState({ loading: true }, async () => {
      await this.props.phrasesActions.getSpecificPhrase(id);
      //await this.props.configureActions.getDepartments();
      //await this.props.configureActions.getGroups();
      this.setState({ loading: false });
    });
  }

  onEditPhrase = (params) => {
    const { id, departmentId } = this.props.match.params;
    this.setState(
      { isSubmitting: true },
      async () =>
        await this.props.phrasesActions
          .editPhrase(id, {
            ...params,
            departmentId,
            groupId: 0,
          })
          .then(() => this.props.history.goBack())
          .catch(() => this.setState({ isSubmitting: false })),
    );
  };
  render() {
    if (this.state.loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    // if (Object.keys(phrase).length) {
    //   if (departments.length) {
    //     const dept = departments.filter(
    //       (dept) => dept.id === phrase.departmentId,
    //     );
    //     if (dept.length) {
    //       phrase.departmentName = dept[0].name;
    //     } else {
    //       phrase.departmentName = '';
    //     }
    //   }
    //   if (groups.length) {
    //     const group = groups.filter(
    //       (group) => group.id === phrase.departmentId,
    //     );
    //     if (group.length) {
    //       phrase.groupName = group[0].name;
    //     } else {
    //       phrase.groupName = '';
    //     }
    //   }
    // }
    return <EditPhrasePage {...this.state} onEditPhrase={this.onEditPhrase} />;
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    phrases: state.phrases,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    phrasesActions: bindActionCreators(
      Object.assign({}, phrasesActions),
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPhrase);
